export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12942.ff979417.jpg";